import { Injectable } from "@angular/core";
import { environment } from "@apps/patient-core/src/app/environments/environment";

@Injectable({ providedIn: "root" })
export class LoggerService {
  public log(...msgs): boolean {
    return this._guardedLog("info", ...msgs);
  }

  public error(...msgs): boolean {
    try {
      console.error(msgs.toString());
    } catch (e) {
      console.error("Error logging error", e);
    }
    return this._guardedLog("error", ...msgs);
  }

  public debug(...msgs): boolean {
    return this._guardedLog("debug", ...msgs);
  }

  private _guardedLog(type: string, ...msgs: string[]): boolean {
    if (environment.production === true) {
      return false;
    }
    if (typeof console[type] !== "function") {
      throw new Error(`Logger method '${type}' does not exist.`);
    }
    console[type](`[${type.toUpperCase()}]`, ...msgs);

    return true;
  }
}
